<template>
  <div class="footer">
    <div class="tips">
      <span>客服热线：</span>

    <span>96345</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
.footer {
  margin: 15px 0;

  
}
.tips {
  text-align: center;
 span:nth-child(1) {
  }
  span:nth-child(2) {
    color: #ff991d;
  }
}
</style>
